import { createRouter, createWebHistory } from 'vue-router'

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/project/:slug',
    name: 'ProjectDetail',
    component: () => import('@/views/ProjectDetail.vue')
  },
  {
    path: '/blog/:slug',
    name: 'BlogPost',
    component: () => import('@/views/BlogPost.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash != from.hash) {
      if (to.hash == "")
        return { top: 0 };
      return (async () => {
        if(document.getElementById(to.hash.substring(1)) == null)
        {
          await timeout(100);
        }
        return { el: to.hash }
      })();
    } else {
      console.log("Returning");
      return { top: 0 };
    }
  }
})

export default router
